{
    "Profile_Drivers_Claim.claim": "FR: Claim",
    "Profile_Drivers_Claim.claimDetails": "FR: Claim Details",
    "Profile_Drivers_Claim.dateOfClaim": "FR: Date of Claim",
    "Profile_Drivers_Claim.claimReason": "FR: Claim Reason",
    "Profile_Drivers_Claim.lossAmount": "FR: Loss Amount",
    "Profile_Drivers_Claim.atFault": "FR: At Fault?"
}
